import React, { useEffect, useState } from 'react';
import { locales } from '../../../translations/locales';
import AlertDetails from './AlertDetails';
import Controls from './Controls';
import Entrie from './Entrie';

const ManageAlert = (props) => {
    const { mission, locale, theme, setOpenAlert, ModuleRP, buildings, vehicleModels, players } = props;

    const [closeMission, setCloseMission] = useState(false);

    const confirmCloseMission = () => {
        if (closeMission) {
            ModuleRP.closeMission(mission.id);
            setOpenAlert(false);
        }
    };

    useEffect(() => {
        if (mission && mission.notifications.length === 0) {
            ModuleRP.alarm.pause();
        }
    }, [mission, players]);

    return (
        <div className={`alert alert-${theme === 'DARK' ? 'dark' : 'light'}`}>
            <div className='row'>
                <div className='col-12'>
                    <button type='button' className='btn btn-sm btn-danger p-0 pl-1 pr-1 float-right m-1' onClick={() => setOpenAlert(false)}>
                        x
                    </button>
                    {
                        !closeMission ? (
                            <button type='button' className='btn btn-sm btn-info p-0 pl-1 pr-1 float-right m-1' onClick={() => setCloseMission(true)}>
                                {locales[locale].sgo.closeMission}
                            </button>
                        ) : (
                            <>
                                <button type='button' className='btn btn-sm btn-danger p-0 pl-1 pr-1 float-right m-1' onClick={confirmCloseMission}>
                                    {locales[locale].yes}
                                </button>
                                <button type='button' className='btn btn-sm btn-secondary p-0 pl-1 pr-1 float-right m-1' onClick={() => setCloseMission(false)}>
                                    {locales[locale].no}
                                </button>
                                <span className='float-right m-1 text-danger'>
                                    {locales[locale].sgo.confirmCloseMission}
                                </span>
                            </>
                        )
                    }

                </div>
            </div>
            {
                mission.notifications.length > 0 && (
                    <div className='d-flex flex-row-reverse row'>
                        {
                            mission.notifications.map((notification) => (
                                <div
                                    className='col-6 btn btn-warning text-left m-1' key={notification.id}
                                    onClick={() => ModuleRP.acknowledgeNotification(mission.id, notification.id)}
                                >
                                    <div
                                        className='btn btn-warning p-0 p-2 m-1 float-right'
                                    >
                                        {locales[locale].sgo.acknowledge}
                                    </div>
                                    <Entrie locale={locale} entrie={notification} />
                                </div>
                            ))
                        }
                    </div>
                )
            }
            <div className='row'>
                <AlertDetails mission={mission} locale={locale} />
                <Controls locale={locale} mission={mission} ModuleRP={ModuleRP} buildings={buildings} vehicleModels={vehicleModels} players={players} />
            </div>
        </div>
    );
};

export default ManageAlert;
